// extracted by mini-css-extract-plugin
export default {"table_container":"Table_table_container__29J2r","table_head":"Table_table_head__NJzHj","table_head_th":"Table_table_head_th__yIsfP","image":"Table_image__vO1Tf"};